import { hu as reacthu } from '@ews/react-translations';

const hu = {
...reacthu
}
export default hu
